import React from 'react';
import {
  HiSearch as _HiSearch,
  HiX as _HiX,
  HiSparkles as _HiSparkles,
  HiOutlineTag as _HiOutlineTag,
  HiArrowNarrowRight as _HiArrowNarrowRight,
  HiCheckCircle as _HiCheckCircle,
  HiFire as _HiFire,
  HiGift as _HiGift,
  HiShieldCheck as _HiShieldCheck,
  HiArrowLeft as _HiArrowLeft,
  HiOutlineClipboardCopy as _HiOutlineClipboardCopy,
  HiCheck as _HiCheck,
  HiExternalLink as _HiExternalLink,
  HiShare as _HiShare,
  HiDownload as _HiDownload
} from 'react-icons/hi';
import {
  FaWhatsapp as _FaWhatsapp,
  FaTwitter as _FaTwitter,
  FaFacebookF as _FaFacebookF,
  FaEnvelope as _FaEnvelope,
  FaLink as _FaLink
} from 'react-icons/fa';

export const HiSearch = _HiSearch as unknown as React.FC<React.SVGProps<SVGSVGElement> & { className?: string }>;
export const HiX = _HiX as unknown as React.FC<React.SVGProps<SVGSVGElement> & { className?: string }>;
export const HiSparkles = _HiSparkles as unknown as React.FC<React.SVGProps<SVGSVGElement> & { className?: string }>;
export const HiOutlineTag = _HiOutlineTag as unknown as React.FC<React.SVGProps<SVGSVGElement> & { className?: string }>;
export const HiArrowNarrowRight = _HiArrowNarrowRight as unknown as React.FC<React.SVGProps<SVGSVGElement> & { className?: string }>;
export const HiCheckCircle = _HiCheckCircle as unknown as React.FC<React.SVGProps<SVGSVGElement> & { className?: string }>;
export const HiFire = _HiFire as unknown as React.FC<React.SVGProps<SVGSVGElement> & { className?: string }>;
export const HiGift = _HiGift as unknown as React.FC<React.SVGProps<SVGSVGElement> & { className?: string }>;
export const HiShieldCheck = _HiShieldCheck as unknown as React.FC<React.SVGProps<SVGSVGElement> & { className?: string }>;
export const HiArrowLeft = _HiArrowLeft as unknown as React.FC<React.SVGProps<SVGSVGElement> & { className?: string }>;
export const HiOutlineClipboardCopy = _HiOutlineClipboardCopy as unknown as React.FC<React.SVGProps<SVGSVGElement> & { className?: string }>;
export const HiCheck = _HiCheck as unknown as React.FC<React.SVGProps<SVGSVGElement> & { className?: string }>;
export const HiExternalLink = _HiExternalLink as unknown as React.FC<React.SVGProps<SVGSVGElement> & { className?: string }>;
export const HiShare = _HiShare as unknown as React.FC<React.SVGProps<SVGSVGElement> & { className?: string }>;
export const HiDownload = _HiDownload as unknown as React.FC<React.SVGProps<SVGSVGElement> & { className?: string }>;

export const FaWhatsapp = _FaWhatsapp as unknown as React.FC<React.SVGProps<SVGSVGElement> & { className?: string }>;
export const FaTwitter = _FaTwitter as unknown as React.FC<React.SVGProps<SVGSVGElement> & { className?: string }>;
export const FaFacebookF = _FaFacebookF as unknown as React.FC<React.SVGProps<SVGSVGElement> & { className?: string }>;
export const FaEnvelope = _FaEnvelope as unknown as React.FC<React.SVGProps<SVGSVGElement> & { className?: string }>;
export const FaLink = _FaLink as unknown as React.FC<React.SVGProps<SVGSVGElement> & { className?: string }>;
